export const URL = process.env.REACT_APP_API_URL;
export const PERSEED_URL = process.env.REACT_APP_PERSEED_API_URL;
